var _g, _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_52_22221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5495 4.65587L20.1095 2.2159L20.1104 2.21673C19.7109 1.81564 19.1698 1.58965 18.6044 1.58966C18.039 1.58967 17.4962 1.81564 17.0984 2.21673L6.07968 13.2355L6.07969 15.6453L3.66981 15.6453L1.92202 17.3931C1.52092 17.7909 1.29494 18.3337 1.29494 18.8991C1.29495 19.4645 1.52093 20.0073 1.92285 20.4059L4.4386 22.9217C5.86702 22.4088 7.46223 22.7666 8.53454 23.8389C9.60689 24.9112 9.96464 26.5064 9.45176 27.9348L11.9675 30.4506C12.3669 30.8517 12.9081 31.0777 13.4735 31.0777C14.0389 31.0776 14.5817 30.8517 14.9795 30.4506L16.8915 28.5385L16.8899 26.4588L18.9662 26.4572L30.1525 15.2709C30.5536 14.8731 30.7796 14.3303 30.7796 13.7649C30.7796 13.1995 30.5536 12.6583 30.1525 12.2589L27.7125 9.81895L27.7134 9.81978C26.2349 10.4377 24.5313 10.1016 23.3988 8.96916C22.2664 7.83676 21.9304 6.13318 22.5482 4.65464L22.5495 4.65587Z",
    fill: "url(#paint0_linear_52_22221)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.6793,
    cy: 15.6152,
    r: 6.90582,
    fill: "#352006"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1973 17.5054C18.2851 17.6737 18.3513 17.8475 18.3961 18.0229C18.5955 18.8044 18.3809 19.6326 17.7334 20.1028C17.1142 20.5526 16.4057 20.5144 16.1734 20.5019C16.1444 20.5003 16.1228 20.4991 16.1098 20.4994C14.9022 20.5225 13.7305 19.2758 13.1048 18.5701C12.2507 17.6065 11.9684 17.0502 11.765 16.37C11.5086 15.5121 12.5161 14.5148 13.1371 14.4948C13.1358 14.4974 13.1344 14.5001 13.133 14.5028C13.0394 14.6819 12.7995 15.1413 13.7547 16.8292C13.9705 17.2105 14.7903 18.5175 15.5121 19.4732C15.919 20.012 16.3121 20.4721 16.6771 20.4263C17.0943 20.374 17.3089 20.0288 17.2624 19.5992C17.2204 19.2122 17.0789 18.7795 16.7109 18.1674C16.3113 17.5027 15.9194 16.9097 15.5659 16.3747C14.9184 15.3947 14.3996 14.6097 14.1984 13.9367C13.9419 13.0788 14.9495 12.0814 15.5705 12.0615C15.5595 12.0827 15.5419 12.1033 15.5219 12.1268C15.378 12.296 15.105 12.6169 16.188 14.3959C16.3726 14.699 16.5097 14.9034 16.7014 15.1893C16.9801 15.6048 17.3742 16.1925 18.1973 17.5054ZM20.0329 17.4009C19.6096 17.7255 18.9218 17.7493 18.3367 17.5712C18.9578 17.5724 19.809 17.0963 18.9017 15.4687C18.4818 14.7155 18.0551 14.0665 17.6819 13.4989C17.1379 12.6715 16.7075 12.0169 16.5774 11.4642C16.364 10.5574 17.6159 9.50395 18.1506 9.61547C17.9122 9.80023 17.6952 10.1704 18.5763 11.6812C19.3772 13.0547 19.783 13.7075 20.0174 14.0844C20.3194 14.5702 20.3366 14.5978 20.5475 15.1195C20.8611 15.8951 20.7866 16.8228 20.0329 17.4009Z",
    fill: "url(#paint1_linear_52_22221)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3726 16.2077L17.3731 16.2081C18.6469 16.9185 18.9244 15.6377 18.7129 15.1386C18.7756 15.2465 18.8384 15.3564 18.901 15.4687C19.8082 17.0961 18.9572 17.5722 18.3362 17.5712C18.2959 17.5624 18.2557 17.552 18.2155 17.5407C18.2142 17.5381 18.2129 17.5355 18.2116 17.5329C18.2071 17.5237 18.2025 17.5145 18.1978 17.5054C18.1978 17.5054 17.7959 16.8643 17.3726 16.2077ZM15.1446 18.9532C15.1871 18.9624 15.2299 18.9696 15.2733 18.9744C16.3246 19.0871 16.5909 18.1841 16.3841 17.6324C16.4009 17.6591 16.4177 17.6859 16.4344 17.7126C16.8169 18.3227 17.1902 18.9181 17.264 19.5992C17.3106 20.0288 17.096 20.374 16.6787 20.4263C16.3137 20.4721 15.9207 20.012 15.5137 19.4731C15.3905 19.3099 15.2665 19.1343 15.1446 18.9532Z",
    fill: "#50330F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_52_22221",
    x: 0.665489,
    y: 1.58966,
    width: 30.7432,
    height: 30.7469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.629433
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.314716
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.42 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_52_22221"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_52_22221",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_22221",
    x1: -0.811722,
    y1: -7.42857,
    x2: -10.4677,
    y2: 25.1195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF854F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252604,
    stopColor: "#E7B06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#B58240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778646,
    stopColor: "#E7B06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7702A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52_22221",
    x1: 10.0915,
    y1: 5.90845,
    x2: 6.03722,
    y2: 18.5318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF854F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252604,
    stopColor: "#E7B06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#B58240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778646,
    stopColor: "#E7B06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7702A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.fb644afc0cb837d25990ee2a70d4f590.svg";
export { ForwardRef as ReactComponent };